import styled from "styled-components";

export const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  flex-direction: column;
  row-gap: 10px;
  background-color: #eff2f7;
`;

export const ErrorMainMessage = styled.span`
  font-family: "Roboto", sans-serif;
  font-size: 35px;
  max-width: 500px;
  text-align: center;
`;
